import React from 'react'
import { useSelector } from 'react-redux'

import NewsroomNews from '../newsroomNews'
import SliderContent from '../sliderContent'
import PushContent from '../pushContent'

import trads from '../../intl/trads.json'

const Hub = ({pushPages, events, news, documents, pressReleases, socials}) => {
  const lang = useSelector(state => state.lang)

  return (
    <div className="newsroom-hub">
      <NewsroomNews news={news} socials={socials} />
      
      { events && events.length > 0 &&
        <SliderContent
          title={trads[lang].newsroom.events}
          items={events}
          contentType="event"
          hasCta={true} />
      }

      { pressReleases && pressReleases.length > 0 &&
          <SliderContent  
            title={trads[lang].newsroom.pressReleaseTitle}
            items={pressReleases}
            contentType="press"
            hasCta={true} />
        }

      { documents && documents.length > 0 &&
        <SliderContent  
          title={trads[lang].newsroom.documents}
          items={documents}
          contentType="publi"
          hasCta={true} />
      }

      <PushContent data={pushPages} />
    </div>
  )
}

export default Hub